// eslint-disable-next-line no-unused-vars
function maxReducer(acc, curr, max) {
  if (curr > acc && curr <= max) {
    return curr
  }

  return acc
}

function addReducer(acc, curr) {
  return acc + curr
}

export default function calculations(state) {
  const savings = {
    revenue: [
      (state.R / 8760) * 0.8 * state.D * 0.25 * 0.8,
      ((state.R / 8760) * 0.8 * state.D * 0.25 * 1.2 ** (2 - 1)) /
        1.06 ** (2 - 1),
      ((state.R / 8760) * 0.8 * state.D * 0.25 * 1.2 ** (3 - 1)) /
        1.06 ** (3 - 1),
      ((state.R / 8760) * 0.8 * state.D * 0.25 * 1.2 ** (4 - 1)) /
        1.06 ** (4 - 1),
    ],
    productivity: [
      ((state.U * state.US) / 2080) *
        1.314 *
        state.S *
        state.HR *
        0.2 *
        (state.P / 100) *
        0.25 *
        0.8,
      (((state.U * state.US) / 2080) *
        1.314 *
        state.S *
        state.HR *
        0.2 *
        (state.P / 100) *
        0.25 *
        1.2 ** (2 - 1)) /
        1.06 ** (2 - 1),
      (((state.U * state.US) / 2080) *
        1.314 *
        state.S *
        state.HR *
        0.2 *
        (state.P / 100) *
        0.25 *
        1.2 ** (3 - 1)) /
        1.06 ** (3 - 1),
      (((state.U * state.US) / 2080) *
        1.314 *
        state.S *
        state.HR *
        0.2 *
        (state.P / 100) *
        0.25 *
        1.2 ** (4 - 1)) /
        1.06 ** (4 - 1),
    ],
    troubleshooting: [
      ((state.E * state.ES) / 2080) * 1.314 * state.S * state.HR * 0.25 * 0.8,
      (((state.E * state.ES) / 2080) *
        1.314 *
        state.S *
        state.HR *
        0.25 *
        1.2 ** (2 - 1)) /
        1.06 ** (2 - 1),
      (((state.E * state.ES) / 2080) *
        1.314 *
        state.S *
        state.HR *
        0.25 *
        1.2 ** (3 - 1)) /
        1.06 ** (3 - 1),
      (((state.E * state.ES) / 2080) *
        1.314 *
        state.S *
        state.HR *
        0.25 *
        1.2 ** (4 - 1)) /
        1.06 ** (4 - 1),
    ],
  }

  const savingsByYear = {
    1: [
      savings.revenue[0],
      savings.productivity[0],
      savings.troubleshooting[0],
    ],
    2: [
      savings.revenue[1],
      savings.productivity[1],
      savings.troubleshooting[1],
    ],
    3: [
      savings.revenue[2],
      savings.productivity[2],
      savings.troubleshooting[2],
    ],
    4: [
      savings.revenue[3],
      savings.productivity[3],
      savings.troubleshooting[3],
    ],
  }

  const savingsUndiscountedByYear = {
    1: savingsByYear['1'].reduce(addReducer) * 1.06 ** (1 - 1),
    2: savingsByYear['2'].reduce(addReducer) * 1.06 ** (2 - 1),
    3: savingsByYear['3'].reduce(addReducer) * 1.06 ** (3 - 1),
    4: savingsByYear['4'].reduce(addReducer) * 1.06 ** (4 - 1),
  }

  const totalSavings = Object.keys(savings)
    .reduce((r, k) => r.concat(savings[k]), [])
    .reduce(addReducer)

  const costs = {
    opt1: [
      60000 + (state.DO - 3) * 16200,
      (60000 + (state.DO - 3) * 16200) / 1.06 ** (2 - 1),
      (60000 + (state.DO - 3) * 16200) / 1.06 ** (2 - 1) / 1.06 ** (3 - 1),
      (60000 + (state.DO - 3) * 16200) /
        1.06 ** (2 - 1) /
        1.06 ** (3 - 1) /
        1.06 ** (4 - 1),
    ],
    opt2: [
      120000 + (state.DO - 5) * 19200,
      (120000 + (state.DO - 5) * 19200) / 1.06 ** (2 - 1),
      (120000 + (state.DO - 5) * 19200) / 1.06 ** (2 - 1) / 1.06 ** (3 - 1),
      (120000 + (state.DO - 5) * 19200) /
        1.06 ** (2 - 1) /
        1.06 ** (3 - 1) /
        1.06 ** (4 - 1),
    ],
    opt3: [
      state.CL >= 4
        ? 120000 + (Math.ceil(state.N * 0.1 - 50) / 10) * 19200
        : 60000 + (Math.ceil(state.N * 0.1 - 30) / 10) * 16200,
      (state.CL >= 4
        ? 120000 + (Math.ceil(state.N * 0.1 - 50) / 10) * 19200
        : 60000 + (Math.ceil(state.N * 0.1 - 30) / 10) * 16200) /
        1.06 ** (2 - 1),
      (state.CL >= 4
        ? 120000 + (Math.ceil(state.N * 0.1 - 50) / 10) * 19200
        : 60000 + (Math.ceil(state.N * 0.1 - 30) / 10) * 16200) /
        1.06 ** (2 - 1) /
        1.06 ** (3 - 1),
      (state.CL >= 4
        ? 120000 + (Math.ceil(state.N * 0.1 - 50) / 10) * 19200
        : 60000 + (Math.ceil(state.N * 0.1 - 30) / 10) * 16200) /
        1.06 ** (2 - 1) /
        1.06 ** (3 - 1) /
        1.06 ** (4 - 1),
    ],
  }

  // Adds up each opt year over year
  const costsYearOverYearPerOpt = [
    costs.opt1.reduce(addReducer),
    costs.opt2.reduce(addReducer),
    costs.opt3.reduce(addReducer),
  ]

  // Greatest of `costsYearOverYearPerOpt` without going over total savings
  const greatestOfYearOverYearPerOptCosts = Math.max(
    costsYearOverYearPerOpt.reduce((acc, curr) => {
      if (curr <= totalSavings) {
        return acc.concat(curr)
      }

      return acc
    }, [])
  )

  // eslint-disable-next-line no-unused-vars
  const costsByYear = {
    1: [costs.opt1[0], costs.opt2[0], costs.opt3[0]],
    2: [costs.opt1[1], costs.opt2[1], costs.opt3[1]],
    3: [costs.opt1[2], costs.opt2[2], costs.opt3[2]],
    4: [costs.opt1[3], costs.opt2[3], costs.opt3[3]],
  }

  // G29 from sheet
  const costsTotal =
    greatestOfYearOverYearPerOptCosts === 0
      ? Math.min([costsYearOverYearPerOpt])
      : greatestOfYearOverYearPerOptCosts

  /* eslint-disable no-nested-ternary */
  const costsMaxCalculatedByYearUPDATED = {
    // =if($G$29=$G$25,C25,if($G$29=$G$26,C26,C27))
    1:
      costsTotal === costsYearOverYearPerOpt[0]
        ? costs.opt1[0]
        : costsTotal === costsYearOverYearPerOpt[1]
        ? costs.opt2[0]
        : costs.opt3[0],
    // =if($G$29=$G$25,D25,if($G$29=$G$26,D26,D27))
    2:
      costsTotal === costsYearOverYearPerOpt[0]
        ? costs.opt1[1]
        : costsTotal === costsYearOverYearPerOpt[1]
        ? costs.opt2[1]
        : costs.opt3[1],
    // =if($G$29=$G$25,E25,if($G$29=$G$26,E26,E27))
    3:
      costsTotal === costsYearOverYearPerOpt[0]
        ? costs.opt1[2]
        : costsTotal === costsYearOverYearPerOpt[1]
        ? costs.opt2[2]
        : costs.opt3[2],
    // =if($G$29=$G$25,F25,if($G$29=$G$26,F26,F27))
    4:
      costsTotal === costsYearOverYearPerOpt[0]
        ? costs.opt1[3]
        : costsTotal === costsYearOverYearPerOpt[1]
        ? costs.opt2[3]
        : costs.opt3[3],
  }
  /* eslint-enable no-nested-ternary */

  const totalCostsMaxCalculatedByYearUPDATED =
    costsMaxCalculatedByYearUPDATED[1] +
    costsMaxCalculatedByYearUPDATED[2] +
    costsMaxCalculatedByYearUPDATED[3] +
    costsMaxCalculatedByYearUPDATED[4]

  const costsMaxCalculatedUndiscountedByYear = {
    1: costsMaxCalculatedByYearUPDATED['1'] * 1.06 ** (1 - 1),
    2: costsMaxCalculatedByYearUPDATED['2'] * 1.06 ** (2 - 1),
    3: costsMaxCalculatedByYearUPDATED['3'] * 1.06 ** (3 - 1),
    4: costsMaxCalculatedByYearUPDATED['4'] * 1.06 ** (4 - 1),
  }

  const totalCostsMaxCalculatedUndiscounted = Object.keys(
    costsMaxCalculatedUndiscountedByYear
  )
    .reduce((r, k) => r.concat(costsMaxCalculatedUndiscountedByYear[k]), [])
    .reduce(addReducer)

  const paybackByYear = {
    1: Math.max(
      0,
      savingsUndiscountedByYear['1'] > totalCostsMaxCalculatedUndiscounted
        ? totalCostsMaxCalculatedUndiscounted / savingsUndiscountedByYear['1']
        : 1
    ),
    2: Math.max(
      0,
      savingsUndiscountedByYear['1'] + savingsUndiscountedByYear['2'] >
        totalCostsMaxCalculatedUndiscounted
        ? (totalCostsMaxCalculatedUndiscounted -
            savingsUndiscountedByYear['1']) /
            savingsUndiscountedByYear['2']
        : 1
    ),
    3: Math.max(
      0,
      savingsUndiscountedByYear['1'] +
        savingsUndiscountedByYear['2'] +
        savingsUndiscountedByYear['3'] >
        totalCostsMaxCalculatedUndiscounted
        ? (totalCostsMaxCalculatedUndiscounted -
            (savingsUndiscountedByYear['1'] + savingsUndiscountedByYear['2'])) /
            savingsUndiscountedByYear['3']
        : 1
    ),
    4: Math.max(
      0,
      savingsUndiscountedByYear['1'] +
        savingsUndiscountedByYear['2'] +
        savingsUndiscountedByYear['3'] +
        savingsUndiscountedByYear['4'] >
        totalCostsMaxCalculatedUndiscounted
        ? (totalCostsMaxCalculatedUndiscounted -
            (savingsUndiscountedByYear['1'] +
              savingsUndiscountedByYear['2'] +
              savingsUndiscountedByYear['3'])) /
            savingsUndiscountedByYear['4']
        : 1
    ),
  }

  return {
    roi: Math.round(
      ((totalSavings - totalCostsMaxCalculatedByYearUPDATED) /
        totalCostsMaxCalculatedByYearUPDATED) *
        100
    ),
    paybackPeriod:
      Math.round(
        Object.keys(paybackByYear)
          .reduce((r, k) => r.concat(paybackByYear[k]), [])
          .reduce(addReducer) * 10
      ) / 10,
  }
}
